import { Result } from '../../../Shared/Protocol/protocol-result'
import { HCPFlowService } from '../../../Services/HCP/flows/hcp-flow.service'
import { IMoveHCPFlowCardPayload } from '../../../Services/HCP/flows/hcp-flow.interface'
import { IHCPFlowKanbanCard } from '../../../Services/HCP/flows/hcp-flow-card.interface'
import { normalizeKanbanCard } from '../../../Services/HCP/flows/hcp-flow.mapper'

function asRecord(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object') return null
  return value as Record<string, unknown>
}

function normalizePositionResponse(value: unknown): IHCPFlowKanbanCard | null {
  const raw = asRecord(value)
  if (!raw) return null

  const nested = asRecord(raw.orderProduct ?? raw.order_product)
  if (nested) return normalizeKanbanCard(nested)

  return normalizeKanbanCard(raw)
}

export class MoveHCPFlowCardUseCase {
  constructor(private readonly hcpFlowService: HCPFlowService) {}

  public async handle(payload: IMoveHCPFlowCardPayload): Promise<Result<IHCPFlowKanbanCard[]>> {
    try {
      const { flow, statusSequence, orderProductIds } = payload

      if (!orderProductIds.length) {
        return Result.fail(new Error('Nenhum item encontrado para movimentar.'))
      }

      const results = await Promise.all(
        orderProductIds.map((orderProductId) =>
          this.hcpFlowService.updateFlowPosition(orderProductId, { flow, statusSequence })
        )
      )

      const failed = results.find((result) => !result.isSuccess)
      if (failed) {
        return Result.fail(failed.error as Error)
      }

      const updatedCards = results
        .map((result) => normalizePositionResponse(result.getValue()))
        .filter(Boolean) as IHCPFlowKanbanCard[]

      return Result.ok(updatedCards)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
